import type { IconSvgObject } from './types';

const PlusMinusIcon: IconSvgObject = [
  ["path", { d: "M8.00018 6V8M8.00018 8V10M8.00018 8H10.0002M8.00018 8H6.00018M5.00018 13H11.0002C12.1048 13 13.0002 12.1046 13.0002 11V5C13.0002 3.89543 12.1048 3 11.0002 3H5.00018C3.89561 3 3.00018 3.89543 3.00018 5V11C3.00018 12.1046 3.89561 13 5.00018 13Z", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.0002 11H19.0002C20.1048 11 21.0002 11.8954 21.0002 13V19C21.0002 20.1046 20.1048 21 19.0002 21H13.0002C11.8956 21 11.0002 20.1046 11.0002 19V16M14.0002 16H18.0002", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default PlusMinusIcon;
